import { Box, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

import PageWrapper from '/components/page-wrapper'
import ManagePassesMenu from './manage-passes-menu'

const ManagePassSubpageLayout = ({ title, HelpText, heading, template, pass, selectedPasses = pass ? [pass] : [], onClose, children }) => (
  <PageWrapper
    title={title}
    HelpText={HelpText}
    heading={heading}
    selectedTemplate={template}
    menu={<ManagePassesMenu template={template} selectedPass={pass} selectedPasses={selectedPasses} />}
  >
    <Box sx={{ height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <Box sx={{ flex: '0 0 48px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', px: 2 }}>
        <IconButton onClick={onClose} aria-label="Close">
          <CloseIcon />
        </IconButton>
      </Box>
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
        {children}
      </Box>
    </Box>
  </PageWrapper>
)

export default ManagePassSubpageLayout
